import { useTranslation } from "react-i18next";
import { cn, sectionDivider, textSectionTitle } from "@design-system";
import { RequirementSummary } from "../VehicleFeatures/RequirementSummary";
import { useOrderRequirements } from "../VehicleFeatures/useOrderRequirements";

export function OrderRequirementsSection({
  workspaceId,
  orderId,
}: {
  workspaceId: string;
  orderId: string;
}) {
  const { t } = useTranslation("workspace");
  const query = useOrderRequirements(workspaceId, orderId);
  if (!query.isError && query.data && !query.data.requirements?.length)
    return null;
  return (
    <>
      <div className={sectionDivider} />
      <section aria-label={t("features.requirements")}>
        <p className={cn(textSectionTitle, "mb-3")}>
          {t("features.requirements")}
        </p>
        {query.isError ? (
          <p role="alert" className="text-sm text-danger">
            {t("features.loadRequirementsError")}{" "}
            <button
              type="button"
              className="underline"
              onClick={() => query.refetch()}
            >
              {t("features.reload")}
            </button>
          </p>
        ) : query.data ? (
          <RequirementSummary
            definitions={query.data.schema.definitions}
            requirements={query.data.requirements || []}
            showLabel={false}
          />
        ) : (
          <p role="status" className="text-sm text-secondary">
            {t("features.loading")}
          </p>
        )}
      </section>
    </>
  );
}
